var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-05-27
 * @brief EHP List 컴포넌트
 *
 ********************************************************************/
import React, { useState, useEffect, useRef } from "react";
//
import { useAsync } from "react-async";
// recoli & state
import { useRecoilValue, useSetRecoilState, useResetRecoilState } from "recoil";
import { userInfoLoginState, } from '../../../recoil/userState';
import { itemState, nextItemState, beforeItemState, checkStep, curCheckValueDto, getTempSave, tempCheckValue, getStepDone } from '../../../recoil/assessmentState';
//
import { useTrans } from "../../../utils/langs/useTrans";
//utils
import * as HttpUtil from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import clog from "../../../utils/logUtils";
import * as CONST from "../../../utils/Const";
//
import $ from "jquery";
import EhpPagination from "../../common/pagination/EhpPagination";
/**
 * @brief EHP List 컴포넌트, 반응형 동작
 * @param param0 curTreeData : Tree에서 선택한 SPG
 * @param param1
 * @returns react components
 */
function BasicList(props) {
    //trans
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const curItem = useRecoilValue(itemState);
    const resetRecoilCurItem = useResetRecoilState(itemState); // recoil userState
    const nextItem = useRecoilValue(nextItemState);
    const beforeItem = useRecoilValue(beforeItemState);
    const setRecoilCurItem = useSetRecoilState(itemState); // recoil userState
    const setRecoilBeforeItem = useSetRecoilState(beforeItemState); // recoil userState
    const setRecoilNextItem = useSetRecoilState(nextItemState); // recoil userState
    const resetRecoilNextItem = useResetRecoilState(nextItemState); // recoil userState
    const setRecoilCurCheckStep = useSetRecoilState(checkStep);
    const resetRecoilTsCheckVal = useResetRecoilState(curCheckValueDto);
    //const setRecoilCurItem = useSetRecoilState(setItemSelectState);
    const isTempSave = useRecoilValue(getTempSave);
    const tempCheckVal = useRecoilValue(tempCheckValue);
    const stepDone = useRecoilValue(getStepDone);
    const resetRecoilTempCheckVal = useResetRecoilState(tempCheckValue);
    // props
    const reportLoading = props.reportLoading;
    const setParentReportLoading = props.setReportLoading;
    const curEhcType = props.curEhcType;
    const { company, zone, subZone, room, spg } = props.curTreeData;
    //const curItem = props.curItem;
    const setParentItemDetail = props.setItemDetail;
    const setParentReportInfo = props.setReportInfo;
    const statusReload = props.statusReload;
    const setParentPopWin = props.setPopWin;
    //const setParentCurItem = props.setCurItem;
    //const setParentInitCheckItem = props.setInitCheckItem;
    //clog("IN BASIC : SELECTED ITEM : " + JSON.stringify(curItem));
    //
    const [itemCheckList, setItemCheckList] = useState([]);
    //page
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0, "psize": 10 };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    let appPath = "";
    appPath = 'page=' + pageInfo.number + '&size=' + pageInfo.size;
    const [sortData, setSortData] = useState({ "sortField": "panelName", "sort": "ASC" });
    //const [sortData, setSortData] = useState({ "sortField": "itemName", "sort": "ASC" });
    const [searchType, setSearchType] = useState("");
    const [searchText, setSearchText] = useState("");
    const [searchRText, setSearchRText] = useState("");
    //
    const [newRegistered, setNewRegistered] = useState(true); //새등록
    const [itemExisted, setItemExisted] = useState(true); //기동록
    const [resErrorCode, setResErrorCode] = useState(200);
    const [resErrorMsg, setResErrorMsg] = useState("검색결과가 없습니다.");
    // by - hjo 20220713 input 으로 돌아오는 기능  추가
    const [searchClose, setSerchClose] = useState(false);
    //검색설정 초기화
    useEffect(() => {
        //clog("IN BASIC : INIT : " + curPage);
        //setCurPage(0);
        handleCurPage(0);
        setSearchText("");
        setSearchRText("");
    }, [company, zone, subZone, room, spg, curEhcType]);
    //mobile check
    const [isMobile, setIsMobile] = useState(false);
    const mobileRef = useRef(null); // Mobile Check용
    function resetSearchForm() {
        var searchArea = document.querySelector(".searcharea");
        var btnSearch = "";
        var dsmBlockToggle = "";
        var btnDelete = "";
        for (var i = 0; i < searchArea.children.length; i++) {
            var child = searchArea.children[i];
            if (child.classList.contains("btn-search"))
                btnSearch = child;
            if (child.classList.contains("d-sm-block-toggle"))
                dsmBlockToggle = child;
            if (child.classList.contains("btn-delete"))
                btnDelete = child;
        }
        if (CUTIL.isnull(btnSearch))
            return;
        if (btnSearch.classList.contains("active")) { // 검색버트 처리
            btnSearch.classList.remove("active");
        }
        if (btnSearch.classList.contains("on")) { // 검색버트 처리
            btnSearch.classList.remove("on");
        }
        if (dsmBlockToggle.classList.contains("on")) { // 모바일 input 처리
            dsmBlockToggle.classList.remove("on");
        }
        if (btnDelete.classList.contains("on")) { // 모바일 삭제 버튼 처리
            btnDelete.classList.remove("active");
        }
    }
    useEffect(() => {
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setIsMobile(true);
            }
            else {
                setIsMobile(false);
                resetSearchForm();
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setIsMobile(true);
                if (pageInfo.totalElements == 0) {
                    // 데이터 없는 화면 있는경우 모바일모드가 true가 되는 이슈 
                    setIsMobile(false);
                }
            }
            else {
                setIsMobile(false);
                resetSearchForm();
            }
        }
    }, [pageInfo]);
    //
    //clog("IN BASIC : curPage : " + curPage);
    // 검색 파라미터 조합
    const strNewRegistered = (newRegistered) ? 'true' : 'false';
    const strItemExisted = (itemExisted) ? 'true' : 'false';
    //let appPath = 'page=' + curPage + '&size=' + listSize;
    // before 20220705
    //appPath = appPath + '&companyId='+company.companyId+'&zoneId='+zone.zoneId+'&roomId='+room.roomId+'&spgId='+spg.spgId;
    appPath = appPath + '&roomId=' + room.roomId + '&spgId=' + spg.spgId;
    appPath = appPath + '&newRegistered=' + strNewRegistered;
    appPath = appPath + '&itemExisted=' + strItemExisted;
    appPath = appPath + '&sort=' + sortData.sortField + ',' + sortData.sort;
    if (!CUTIL.isnull(searchType) && (searchType.length > 0) && (searchRText.length > 0)) {
        appPath = appPath + '&' + searchType + '=' + searchRText;
        //clog("검색 등 : " + appPath);
    }
    // 리스트 조회
    //clog("IN BASIC : CHANGE CHECK : " + JSON.stringify(curItem));
    const [listMode, setListMode] = useState("INIT"); //INIT, LIST
    const { data: data, error, isLoading, reload, run } = useAsync({
        promiseFn: HttpUtil.PromiseHttp,
        //deferFn: HttpUtil.Http,
        httpMethod: "GET",
        //appPath: "/api/v2/item/basic?" + appPath,
        appPath: "/api/v2/product/company/zone/subzone/room/panel/item/step/basic?" + appPath,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: statusReload + appPath + listMode + curItem.assessment.assessmentId + isMobile
    });
    useEffect(() => {
        let errList = "";
        if (data) {
            if (data.codeNum == 200) {
                clog("IN BASIC LIST : RES : " + isMobile);
                setItemCheckList(data.body); // list
                //setRetPageInfo(data.data.page);
                setPageInfo(Object.assign(Object.assign({}, data.data.page), { psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT })); //5, 10
                setListMode("LIST");
            }
            else {
                setResErrorCode(data.codeNum);
                data.errorList.map((errMsg, idx) => (errList = errList + errMsg));
                setResErrorMsg(errList);
            }
        }
    }, [data]);
    // ONLY BASIC 새등록 / 기등록
    function handleCheckListType(ctype, val) {
        if (ctype == "새등록") {
            //setCurPage(0);
            handleCurPage(0);
            setNewRegistered(val);
        }
        else if (ctype == "기등록") {
            //setCurPage(0);
            handleCurPage(0);
            setItemExisted(val);
        }
        else {
            clog("UNRegisted work type : " + ctype);
        }
    }
    function onClickGoSearch(e) {
        if (parseInt(tempCheckVal.checkVal.value) > -1) {
            clog("임시저장 상태여서 검색이 안됩니다. ..........................");
            return;
        }
        var searchArea = document.querySelector(".searcharea");
        var btnSearch = "";
        var dsmBlockToggle = "";
        var btnDelete = "";
        for (var i = 0; i < searchArea.children.length; i++) {
            var child = searchArea.children[i];
            if (child.classList.contains("btn-search"))
                btnSearch = child;
            if (child.classList.contains("d-sm-block-toggle"))
                dsmBlockToggle = child;
            if (child.classList.contains("btn-delete"))
                btnDelete = child;
        }
        if (CUTIL.isnull(btnSearch))
            return;
        var selSearchType = $("#search_selected-value").attr("data-value");
        if (isMobile) {
            //setSearchText(""); // 검색어 초기화
            //selSearchType = "itemName";
            selSearchType = "panelName";
            if (!btnSearch.classList.contains("on")) { // 검색버트 처리
                btnSearch.classList.add("on");
                btnSearch.addEventListener("click", function () {
                    btnSearch.classList.add("active");
                    // 검색 후에..
                    //btnSearch.classList.remove("active");
                });
            }
            if (!dsmBlockToggle.classList.contains("on")) { // 모바일 input 처리
                dsmBlockToggle.classList.add("on");
            }
            if (!btnDelete.classList.contains("on")) { // 모바일 삭제 버튼 처리
                btnDelete.classList.add("active");
                btnDelete.addEventListener("click", function () {
                    if (!btnDelete.classList.contains("active"))
                        return;
                    dsmBlockToggle.classList.remove("on");
                    btnSearch.classList.remove("on");
                    btnSearch.classList.remove("active");
                    btnDelete.classList.remove("active");
                });
            }
        }
        //setCurPage(0); // 페이지 초기화
        handleCurPage(0);
        setSearchType(selSearchType);
        setSearchRText(searchText);
        btnSearch.classList.remove("active");
    }
    // select active 액션
    function toggleSelectBox(selectBox) {
        selectBox.classList.toggle("active");
    }
    // option 선택 시  값 변경 액션
    function selectOption(optionElement) {
        const selectBox = optionElement.closest(".select");
        //option 값 selected-value 로 변경
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        // by sjpark
        //selectedElement.textContent = optionElement.textContent;
        clog("OPT VAL : " + optionElement.value);
        clog("OPT VAL : " + optionElement.getAttribute("data-value"));
        selectedElement.setAttribute("data-value", optionElement.getAttribute("data-value"));
    }
    // 검색항목 선택
    function onClickSelect(e) {
        const selectBoxElement = e.currentTarget;
        const targetElement = e.target;
        const isOptionElement = targetElement.classList.contains("option");
        if (isOptionElement) {
            selectOption(targetElement);
        }
        toggleSelectBox(selectBoxElement);
    }
    function onClickSort(e) {
        var actTag = (e.target.tagName == "TH") ? e.target : e.currentTarget;
        var selSortField = actTag.getAttribute("data-value");
        var selSort = (sortData.sort === "ASC") ? "DESC" : "ASC";
        if (selSortField !== sortData.sortField) { // 정렬필드가 변경된 경우
            selSort = "DESC";
        }
        //setCurPage(0); // 페이지 초기화
        handleCurPage(0);
        setSortData({
            "sortField": selSortField,
            "sort": selSort
        });
    }
    ////////////////////////////////////////////////////////
    // popup open
    //const [reportLoading, setReportLoading] = useState(false);
    function onClickReportView(e, ehcType, item) {
        item.ehcType = ehcType;
        item.ehcPos = room.roomName + "/" + spg.spgName;
        if (!CUTIL.isnull(setParentItemDetail))
            setParentItemDetail(item); // 데이터 전달을 위해
        //
        setParentReportInfo(null);
        (() => __awaiter(this, void 0, void 0, function* () {
            setParentReportLoading(true);
            const resp = yield HttpUtil.API_reportView(item.serialNo);
            setParentReportInfo(resp);
            setParentReportLoading(false);
            CUTIL.jsopen_Popup(e);
        }))();
    }
    function onClickListDetailOpen(e, ehcType, item) {
        //e.preventDefault();
        item.ehcType = ehcType;
        item.ehcPos = room.roomName + "/" + spg.spgName;
        if (!CUTIL.isnull(setParentItemDetail))
            setParentItemDetail(item); // 데이터 전달을 위해
        //
        CUTIL.jsopen_Popup(e);
    }
    // 진단점검을 위한 초기화
    function handleCurItem(item) {
        // 20221021
        // ADMIN, USER만 basic 진행을 할 수 있음.
        // alert(userInfo.loginInfo.role);
        if (userInfo.loginInfo.role !== CONST.USERROLE_ENGINEER) {
            itemCheck(item);
        }
    }
    function itemCheck(item) {
        clog("IN BASIC : itemCheck : " + JSON.stringify(item));
        if (curItem.itemId === item.itemId)
            return;
        // parent call but reload list
        const clickItem = {
            spgTree: {
                company: company,
                zone: zone,
                subZone: subZone,
                room: room,
                spg: spg
            },
            ehcType: curEhcType,
            itemId: item.itemId,
            itemName: item.itemName,
            serialNo: item.serialNo,
            itemStatus: item.itemStatus,
            itemStep: item.itemStep,
            responsible: item.responsible,
            assessment: {
                preAssessmentId: item.assessment.preAssessmentId,
                assessmentId: item.assessment.assessmentId,
                totalComment: item.assessment.totalComment,
                reportId: item.assessment.reportId,
                updatedTime: item.assessment.updatedTime,
                isTempSave: item.assessment.isTempSave
            }
        };
        // set next item
        const tsItem = tempCheckVal.item;
        const tsVal = tempCheckVal.checkVal;
        const tsValue = (tempCheckVal.checkVal.value.length > 0) ? parseInt(tempCheckVal.checkVal.value) : -1;
        setRecoilNextItem(clickItem);
        if (curItem.itemId.length <= 0) { // 현재 아이템이 체크되어 있지 않으면...클릭한 아이템을 현재 아이템으로 함
            clog("IN BASIC : " + clickItem.itemId + " : " + "현재 아이템이 체크되어 있지 않으면...클릭한 아이템을 현재 아이템으로 함/단계도 처음으로");
            setRecoilCurItem(clickItem);
        }
        else if (tsValue < 0) {
            setRecoilCurItem(clickItem);
        }
        if (stepDone)
            resetRecoilTempCheckVal();
        //포커스 화면 이동
        location.href = "#focustop";
    }
    // by hjo - 20220713 웹사이즈 닫기버튼 이벤트 추가
    function searchClosed(e) {
        if (searchClose === true) {
            setSerchClose(false);
        }
        setSearchText("");
    }
    // 모바일 사이즈 
    function listDetailView(e, item) {
        return __awaiter(this, void 0, void 0, function* () {
            setParentPopWin("pop-list-view", React.createElement(MobileListDetailView, { htmlHeader: React.createElement("h1", null, "\uC0C1\uC138\uC815\uBCF4"), item: item, setParentReportInfo: setParentReportInfo, setParentReportLoading: setParentReportLoading }));
            CUTIL.jsopen_m_Popup(e);
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("article", { className: `box list ${(isLoading || (reportLoading)) ? "loading__box" : ""}` },
            React.createElement("div", { className: "box__header" },
                React.createElement("p", { className: "box__title" },
                    React.createElement("span", { className: "txt-purple" }, "Basic"),
                    " e-HC List")),
            React.createElement("div", { className: `box__body ${((resErrorCode != 200) || (pageInfo.totalElements <= 0)) ? "nodata" : ""}` },
                React.createElement("div", { className: "tbl__top" },
                    React.createElement("div", { className: "left" },
                        React.createElement("span", null, t("LABEL.등록항목")),
                        React.createElement("ul", { className: "checkBox" },
                            React.createElement("li", null,
                                React.createElement("input", { type: "checkbox", id: "chk1", name: "chklist", checked: newRegistered, onChange: (e) => handleCheckListType("새등록", !newRegistered), readOnly: true }),
                                React.createElement("label", { htmlFor: "chk1" }, t("LABEL.새등록"))),
                            React.createElement("li", null,
                                React.createElement("input", { type: "checkbox", id: "chk2", name: "chklist", checked: itemExisted, onChange: (e) => handleCheckListType("기등록", !itemExisted), readOnly: true }),
                                React.createElement("label", { htmlFor: "chk2" }, t("LABEL.기등록"))))),
                    React.createElement("div", { className: "right" },
                        React.createElement("div", { className: "searcharea" },
                            React.createElement("div", { className: "searchinput" },
                                React.createElement("span", null, t("LABEL.검색")),
                                React.createElement("div", { id: "search_select", className: "select", onClick: (e) => onClickSelect(e) },
                                    React.createElement("div", { className: "selected" },
                                        React.createElement("div", { id: "search_selected-value", className: "selected-value", "data-value": "panelName" }, t("FIELD.Panel명")),
                                        React.createElement("div", { className: "arrow" })),
                                    React.createElement("ul", null,
                                        React.createElement("li", { className: "option", value: "0", "data-value": "panelName" }, t("FIELD.Panel명")),
                                        React.createElement("li", { className: "option", value: "1", "data-value": "serialNo" }, t("FIELD.시리얼번호")),
                                        React.createElement("li", { className: "option", value: "2", "data-value": "responsible" }, t("FIELD.담당자")))),
                                "\u00A0",
                                React.createElement("div", { className: "input__direct" },
                                    (!searchText || !searchClose) &&
                                        React.createElement("input", { type: "text", placeholder: t("MESSAGE.검색어를입력하세요"), value: searchText, onChange: (e) => setSearchText(e.target.value) }),
                                    (searchText || searchClose) &&
                                        React.createElement("button", { type: "button", className: "btn btn-delete", onClick: (e) => searchClosed(e) },
                                            React.createElement("span", { className: "hide" }, "\uC785\uB825 \uCC3D \uB2EB\uAE30")))),
                            React.createElement("input", { type: "text", placeholder: "Panel\uBA85\uC744 \uC785\uB825\uD558\uC138\uC694.", className: "d-sm-block-toggle", value: searchText, onChange: (e) => setSearchText(e.target.value) }),
                            React.createElement("button", { type: "button", className: "btn btn-delete" },
                                React.createElement("span", { className: "hide" }, "\uC785\uB825 \uCC3D \uB2EB\uAE30")),
                            React.createElement("button", { type: "button", className: "btn-search", onClick: (e) => onClickGoSearch(e) },
                                React.createElement("span", null, t("LABEL.조회")))))),
                ((resErrorCode != 200) || (pageInfo.totalElements <= 0)) &&
                    React.createElement("p", { className: "nodata__txt" }, t("MESSAGE.데이터를찾을수없습니다")),
                React.createElement("div", { className: "tbl-list" },
                    React.createElement("table", { summary: "\uAE30\uAE30 \uBA85, \uC81C\uC870\uBC88\uD638, \uB2F4\uB2F9\uC790, \uCD5C\uADFC\uC810\uAC80\uC77C, Step, Report, Memo, \uC131\uC801\uC11C, \uC784\uC2DC\uC800\uC7A5, \uC810\uAC80 \uC9C4\uD589 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C Basic e-HC List \uC785\uB2C8\uB2E4." },
                        React.createElement("caption", null, "Basice-HCList"),
                        React.createElement("colgroup", null,
                            React.createElement("col", null)),
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "panelName") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left`, onClick: (e) => onClickSort(e), "data-value": "panelName" },
                                    React.createElement("span", null, t("FIELD.Panel명"))),
                                React.createElement("th", { scope: "col", ref: mobileRef, className: `sort ${(sortData.sortField === "serialNo") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} d-lm-none txt-left`, onClick: (e) => onClickSort(e), "data-value": "serialNo" },
                                    React.createElement("span", null, t("FIELD.시리얼번호"))),
                                React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "responsible") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} d-lm-none txt-left`, onClick: (e) => onClickSort(e), "data-value": "responsible" },
                                    React.createElement("span", null, t("FIELD.담당자"))),
                                React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "updatedTime") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left`, onClick: (e) => onClickSort(e), "data-value": "updatedTime" },
                                    React.createElement("span", null, t("FIELD.최근점검일"))),
                                React.createElement("th", { scope: "col", className: "d-sm-none" },
                                    React.createElement("span", null, t("FIELD.Step"))),
                                React.createElement("th", { scope: "col", className: "d-sm-none" },
                                    React.createElement("span", null, t("FIELD.Report"))),
                                React.createElement("th", { scope: "col", className: "d-sm-none" },
                                    React.createElement("span", null, t("FIELD.Memo"))),
                                React.createElement("th", { scope: "col", className: "d-sm-none" },
                                    React.createElement("span", null, t("FIELD.성적서"))),
                                (itemCheckList == null)
                                    ? React.createElement("th", { className: "sort asc d-lm-none disabled" },
                                        React.createElement("span", { className: "center" }, t("FIELD.임시저장")))
                                    : React.createElement("th", { className: `sort ${(sortData.sortField === "isTempSave") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} d-lm-none`, onClick: (e) => onClickSort(e), "data-value": "isTempSave" },
                                        React.createElement("span", { className: "center" }, t("FIELD.임시저장"))),
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    React.createElement("span", null, t("FIELD.점검진행"))))),
                        React.createElement("tbody", null, itemCheckList.map((item, idx) => (React.createElement("tr", { key: item.itemId + "_" + idx, className: (item.itemId === curItem.itemId) ? "focused" : "" },
                            React.createElement("td", { className: "txt-left" },
                                React.createElement("span", { className: "tooltip" },
                                    item.panel.panelName,
                                    React.createElement("span", { className: "tooltip-text" }, item.panel.panelName))),
                            React.createElement("td", { className: "txt-left d-lm-none" },
                                React.createElement("p", { className: "ellipsis" },
                                    React.createElement("span", { className: "tooltip" },
                                        item.serialNo,
                                        React.createElement("span", { className: "tooltip-text" }, item.serialNo)))),
                            React.createElement("td", { className: "txt-left d-lm-none" }, item.responsible),
                            /* (userInfo.role == CONST.USERROLE_USER) ? // || ((searchInput.clientHeight <= 0) && (searchInput.clientWidth <= 0)))// by 20221115 - hjo engineer,admin 계정 팝업 변겯
                              <td className="checkdate js-open txt-left" data-pop={"data-detail"} onClick={(e) => onClickListDetailOpen(e, "PREMIUM", item)}>
                                {(CUTIL.isnull(item.assessment.updatedTime)) ? t("MESSAGE.기록없음") : CUTIL.utc2time("YYYY-MM-DD", item.assessment.updatedTime)}
                              </td> */
                            (isMobile) ?
                                React.createElement("td", { className: "checkdate js-open txt-left", "data-pop": "pop-list-view", onClick: (e) => listDetailView(e, item) }, (CUTIL.isnull(item.assessment.updatedTime)) ? t("MESSAGE.기록없음") : CUTIL.utc2time("YYYY-MM-DD", item.assessment.updatedTime))
                                : React.createElement("td", { className: "checkdate txt-left", "data-pop": "data-detail" }, (CUTIL.isnull(item.assessment.updatedTime)) ? t("MESSAGE.기록없음") : CUTIL.utc2time("YYYY-MM-DD", item.assessment.updatedTime)),
                            React.createElement("td", { className: "d-sm-none" },
                                React.createElement("ul", { className: (item.checkStep.name === "ADVANCED")
                                        ? "icon-step all"
                                        : (item.checkStep.name === "PREMIUM")
                                            ? "icon-step two"
                                            : (item.checkStep.name === "BASIC")
                                                ? "icon-step one"
                                                : "icon-step" },
                                    React.createElement("li", null,
                                        React.createElement("span", { className: "hide" }, "1\uB2E8\uACC4")),
                                    React.createElement("li", null,
                                        React.createElement("span", { className: "hide" }, "2\uB2E8\uACC4")),
                                    React.createElement("li", null,
                                        React.createElement("span", { className: "hide" }, "3\uB2E8\uACC4")))),
                            React.createElement("td", { className: "d-sm-none" }, (item.assessment.reportId != null)
                                ? React.createElement("button", { type: "button", className: "btn btn-file", onClick: (e) => { HttpUtil.fileDownload_WithPdfViewer(item.serialNo, item.assessment.reportId, userInfo.loginInfo.token); } },
                                    React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uB2E4\uC6B4\uB85C\uB4DC"))
                                : React.createElement("button", { type: "button", className: "btn btn-file", disabled: true },
                                    React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uB2E4\uC6B4\uB85C\uB4DC"))),
                            React.createElement("td", { className: "d-sm-none" }, (!item.assessment.totalComment)
                                ? React.createElement("button", { type: "button", className: "btn btn-memo", disabled: true },
                                    React.createElement("span", { className: "hide" }, "\uBA54\uBAA8"))
                                : React.createElement("button", { type: "button", className: "btn btn-memo" },
                                    React.createElement("span", { className: "hide" }, "\uBA54\uBAA8"))),
                            React.createElement("td", { className: "d-sm-none" }, (!item.serialNo)
                                ? React.createElement("button", { type: "button", className: "btn btn-file", disabled: true },
                                    React.createElement("span", { className: "hide" }, "\uC131\uC801\uC11C"))
                                : React.createElement("button", { type: "button", className: "btn btn-file js-open", "data-pop": "pop-downtest", onClick: (e) => onClickReportView(e, "BASIC", item) },
                                    React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uB2E4\uC6B4\uB85C\uB4DC"))),
                            React.createElement("td", { className: "d-lm-none" }, (item.itemStep === "BASIC_ING")
                                ? React.createElement("button", { type: "button", className: "btn btn-down", onClick: (e) => handleCurItem(item) },
                                    React.createElement("span", { className: "hide" }, "\uC784\uC2DC\uC800\uC7A5"))
                                : React.createElement("button", { type: "button", className: "btn btn-down", disabled: true },
                                    React.createElement("span", { className: "hide" }, "\uC784\uC2DC\uC800\uC7A5"))),
                            React.createElement("td", null, (CUTIL.isnull(item.itemStep) || (!item.assessment.isTempSave))
                                ? React.createElement("button", { type: "button", className: "bg-purple", onClick: (e) => handleCurItem(item) },
                                    React.createElement("span", null, t("LABEL.시작")),
                                    " ")
                                : React.createElement("button", { type: "button", className: "bg-navy", onClick: (e) => handleCurItem(item) },
                                    React.createElement("span", null, t("LABEL.진행중")))))))))),
                React.createElement(EhpPagination, { componentName: "BASIC", pageInfo: pageInfo, handleFunc: handleCurPage })))));
}
export default BasicList;
function MobileListDetailView(props) {
    //trans
    const t = useTrans();
    //recoil
    //const userInfo = useRecoilValue(userInfoState);
    const userInfo = useRecoilValue(userInfoLoginState);
    //
    const item = (props.item === null) ? null : props.item;
    const list = (props.list === null) ? null : props.list;
    const setParentReportInfo = props.setParentReportInfo;
    const setParentReportLoading = props.setParentReportLoading;
    function onClickReportView(e, item) {
        setParentReportInfo(null);
        (() => __awaiter(this, void 0, void 0, function* () {
            CUTIL.jsclose_Popup("pop-list-view");
            setParentReportLoading(true);
            const resp = yield HttpUtil.API_reportView(item.serialNo);
            setParentReportInfo(resp);
            setParentReportLoading(false);
            CUTIL.jsopen_Popup(e);
        }))();
    }
    function onClickClose(e) {
        CUTIL.jsclose_Popup("pop-list-view");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("div", { className: "area__right_content workplace__info" },
                (item) &&
                    React.createElement("div", { className: "content__info" },
                        React.createElement("h3", { className: "hide" }, "\uB9AC\uC2A4\uD2B8 \uC0C1\uC138 \uC815\uBCF4"),
                        React.createElement("ul", null,
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, t("FIELD.Panel명")),
                                React.createElement("p", { className: "txt" }, (!item.panel.panelName) ? "-" : item.panel.panelName)),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, t("FIELD.시리얼번호")),
                                React.createElement("p", { className: "txt" }, (!item.serialNo) ? "-" : item.serialNo)),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, t("FIELD.최근점검일")),
                                React.createElement("p", { className: "txt" }, (!item.assessment.updatedTime) ? "-" :
                                    CUTIL.utc2time("YYYY-MM-DD", item.assessment.updatedTime))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, t("FIELD.담당자")),
                                React.createElement("p", { className: "txt" }, (!item.responsible) ? "-" : item.responsible)),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, t("FIELD.Report")),
                                React.createElement("div", { className: "txt" },
                                    React.createElement("ul", { className: "filelist" },
                                        React.createElement("li", null,
                                            React.createElement("span", null, "PDF"),
                                            React.createElement("button", { type: "button", className: "btn btn-filedown", onClick: (e) => { HttpUtil.fileDownload_EhcReport(item.itemName, item.assessment.reportId, userInfo.loginInfo.token); } },
                                                React.createElement("span", { className: "hide" }, "\uC0AD\uC81C")))))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, t("FIELD.메모")),
                                React.createElement("div", { className: "txt" },
                                    React.createElement("span", null),
                                    (item.assessment.totalComment == null)
                                        ? React.createElement("button", { type: "button", className: "btn btn-memo", disabled: true },
                                            React.createElement("span", { className: "hide" }, "\uBA54\uBAA8"))
                                        : React.createElement("button", { type: "button", className: "btn btn-memo" },
                                            React.createElement("span", { className: "hide" }, "\uBA54\uBAA8")))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, t("FIELD.성적서")),
                                React.createElement("div", { className: "txt" },
                                    React.createElement("span", null),
                                    (!item.serialNo)
                                        ? React.createElement("button", { type: "button", className: "btn btn-file", disabled: true },
                                            React.createElement("span", { className: "hide" }, "\uC131\uC801\uC11C"))
                                        : React.createElement("button", { type: "button", className: "btn btn-file js-open", "data-pop": "pop-downtest-mobile", onClick: (e) => onClickReportView(e, item) },
                                            React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uB2E4\uC6B4\uB85C\uB4DC")))))),
                React.createElement("div", { className: "btn__wrap" },
                    React.createElement("button", { type: "button", className: "js-close", onClick: (e) => onClickClose(e) },
                        React.createElement("span", null, "\uD655\uC778")))))));
}
